import { useState, useEffect, useCallback } from "react";
import { getRecords } from "../../services/api.service";
import { toast } from "react-toastify";

const useFetchData = (initialPayload, page, pageSize, endpoint, searchfields) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [totalCount, setTotalCount] = useState(0);

    const useDebounce = (value, delay = 500) => {
        const [debouncedValue, setDebouncedValue] = useState(value);

        useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            return () => clearTimeout(handler);
        }, [value, delay]);

        return debouncedValue;
    };
    const debouncedSearchKeyword = useDebounce(searchKeyword, 500);


    const getData = useCallback(async () => {
        try {
            setIsLoading(true);
            let payload = {
                ...initialPayload,
            };

            if (debouncedSearchKeyword) {
                payload.search = {
                    field_name: searchfields || [],
                    searchKeyword: debouncedSearchKeyword,
                };
            } 
            payload.pagination = {
                page: page + 1,
                pageSize: pageSize,
            }
            
            const responseData = await getRecords(payload, endpoint);
            if (responseData.code === 1) {
                setTotalCount(responseData.count);
                const sortedData = responseData.data
                  .map((element, index) => ({
                    ...element,
                    index: index + 1, 
                    // index: page * pageSize + (index + 1), // if you want increment sr.no then use it
                  }))
                  .sort((a, b) => b.index - a.index);
                setData(sortedData);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Something went wrong please try again!")
        } finally {
            setIsLoading(false);
        }
    }, [page, pageSize, debouncedSearchKeyword, initialPayload]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        isLoading,
        setSearchKeyword,
        totalCount,
    };
};

export default useFetchData;